import AddIcon from "@mui/icons-material/Add";
import { Box, Divider, Grid, AccordionSummary as MUIAccordionSummary } from "@mui/material";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ArrowDown from "assets/ArrowDown.svg";
import { ReactComponent as DeleteIcon } from "assets/DeleteIcon.svg";
import { ReactComponent as EditIcon } from "assets/EditIcon.svg";
import { ReactComponent as Ellipse } from "assets/Ellipse.svg";
import { ReactComponent as CopySection } from "assets/copySection.svg";
import { ReactComponent as CopyLink } from "assets/copy_link.svg";
import { setActiveActionCard } from "components/app/App.slice";
import ThemeContext from "components/app/Context";
import Button from "components/common/Button";
import Chip from "components/common/Chip";
import DialogFormation from "components/common/DialogFormation";
import Feedback from "components/common/Feedback";
import KebabMenu from "components/common/KebabMenu";
import MarkCompleteButton from "components/common/MarkCompleteButton";
import { setFeedbackDetails } from "components/common/Snackbar/snackbar.slice";
import Timing from "components/common/Timing";
import Typography from "components/common/Typography";
import ActionCardDialogsContext from "components/features/ActionCard/Context";
import MultiSelectButtons from "components/features/ActionCard/MultiSelectButtons";
import EditSectionForm from "components/features/Sections/Edit";
import { setCopySectionData } from "components/features/planDetails/PlanDetail.slice";
import { useTranslate } from "hooks/useTranslate";
import React, { useContext, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { ABOVE_PROPERTY, FEEDBACK_TIMER, accessTypes, brandDeadLine, messageTypes } from "utils/CommonConstants";
import {
  getChipDetails,
  getHoursAndMin,
  getOwnersList,
  getSectionDuration,
  matchOwnerWithHltId,
  matchPlanType
} from "utils/CommonFunctions";
import { planTypes } from "utils/Types";
import { REDIRECT_URI } from "utils/URLConstants";
import DeleteSection from "../DeleteSection";

interface Props {
  section: any;
  index: number;
  handleAccordianOpen: any;
  open?: boolean;
  multiCardSelect?: boolean;
  handleMultiSelectMode: () => void;
  planType: string;
  planId: number;
}

function AccordionSummary(props: Props) {
  const location = useLocation();
  const translate = useTranslate();
  const dispatch: any = useAppDispatch();
  const formRef = React.useRef<any>(null);
  const { isMobileScreen }: any = useContext(ThemeContext);
  const { index, section, open, handleAccordianOpen, multiCardSelect, handleMultiSelectMode, planType, planId } = props;
  const colorCode = open ? tokens.Primary.Primary400 : tokens.Border.General.Secondary;
  const { setIsOpenCopyActionDialog } = useContext(ActionCardDialogsContext);

  const isCorp = useAppSelector((state) => state.app.loggedInUserDetails.isCorp);
  const restrictPlanType = useAppSelector((state) => state.myPlanDetails.myPlanDetails.planType);
  const selectedMyPlanDetail: any = useAppSelector((state) => state.myPlanDetails.myPlanDetails);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [sectionId, setSectionId] = React.useState<number>(0);
  const [openDialog, setOpenDialog] = React.useState(Boolean);
  const [openDeleteDialog, setOpenDeleteDialog] = React.useState(Boolean);
  const [sectionTitleValue, setSectionTitleValue] = React.useState(String);
  const [isCopyLinkSuccess, setIsCopyLinkSuccess] = useState(false);
  const [sectionDescriptionValue, setSectionDescriptionValue] = React.useState(String);
  const { setIsOpenAddActionDialog, setIsOpenImportActionDialog } = useContext(ActionCardDialogsContext);
  const openCreateMenu = Boolean(anchorEl);

  const isViewMode = useAppSelector((state) => state.myPlanDetails.isViewMode);

  const showMultiSelectButtons =
    !isViewMode &&
    section?.cards?.length &&
    (isCorp ? planType === planTypes.MyPlans : true) &&
    !location?.state?.redirectFromDashboard;

  const SectionMenu = [
    {
      label: "Edit Section",
      icon: EditIcon,
      accessType: accessTypes.update,
      enabled: true,
      action: (prop: any) => {
        if (matchPlanType(restrictPlanType) && section?.cmsSectionId) {
          dispatch(
            setFeedbackDetails({
              shouldShow: true,
              type: "section",
              setState: setFeedbackDetails({ shouldShow: false }),
              actionType: "edit",
              messageType: restrictPlanType === brandDeadLine ? messageTypes.deadlinePlan : messageTypes.initiativePlan
            })
          );
          return;
        }
        setSectionTitleValue(prop.title);
        setSectionDescriptionValue(prop.summary);
        setSectionId(prop.id);
        setOpenDialog(true);
      }
    },
    {
      label: "Delete Section",
      icon: DeleteIcon,
      accessType: accessTypes.delete,
      enabled: true,
      action: (prop: any) => {
        if (!isCorp && !matchOwnerWithHltId(selectedMyPlanDetail?.owners)) {
          dispatch(
            setFeedbackDetails({
              shouldShow: true,
              type: "section",
              setState: setFeedbackDetails({ shouldShow: false }),
              displayName: getOwnersList(),

              messageType:
                selectedMyPlanDetail?.owners.length > 1 ? messageTypes.multipleOwners : messageTypes.singleOwner
            })
          );
          return;
        } else if (matchPlanType(restrictPlanType) && section?.cmsSectionId) {
          dispatch(
            setFeedbackDetails({
              shouldShow: true,
              type: "section",
              setState: setFeedbackDetails({ shouldShow: false }),

              messageType: restrictPlanType === brandDeadLine ? messageTypes.deadlinePlan : messageTypes.initiativePlan
            })
          );
          return;
        } else if (selectedMyPlanDetail?.sections?.length === 1) {
          dispatch(
            setFeedbackDetails({
              shouldShow: true,
              setState: setFeedbackDetails({ shouldShow: false }),
              message: "You can't delete the only section. At least one section is required in a Plan."
            })
          );
          return;
        }
        setSectionId(prop.id);
        setOpenDeleteDialog(true);
      }
    }
  ];

  const getSectionKebabMenu = () => {
    const menuOption: any = [
      {
        label: translate("library.planDetails.section.kebabMenu.copyLinkTitle"),
        icon: CopyLink,
        action: () => {
          const link = REDIRECT_URI + "/plandetails/" + planId + "/" + section?.id + "?isshareable=true";
          navigator.clipboard.writeText(link).then(function () {
            setIsCopyLinkSuccess(true);
          });
          setIsCopyLinkSuccess(false);
        },
        enabled: true
      }
    ];
    if (!isCorp && !location?.state?.redirectFromDashboard)
      menuOption.push({
        label: translate("library.planDetails.section.kebabMenu.copySectionTitle"),
        accessType: accessTypes.update,
        icon: CopySection,
        action: () => {
          dispatch(
            setCopySectionData({
              copySectionType: true,
              dialogTitle: translate("library.planDetails.section.kebabMenu.copySectionTitle"),
              sectionPayload: [section]
            })
          );
          setIsOpenCopyActionDialog(true);
        },
        enabled: true
      });
    return menuOption;
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const formSubmit = () => {
    formRef?.current?.submitForm();
  };

  const handleOpenCreateMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseCreateMenu = () => {
    setAnchorEl(null);
  };

  const handleCreateFromExisting = () => {
    setIsOpenImportActionDialog(section?.id);
    handleCloseCreateMenu();
  };

  const handleCreateNewAction = () => {
    dispatch(setActiveActionCard({ planId, sectionId: section?.id }));
    setIsOpenAddActionDialog(section?.id);
    handleCloseCreateMenu();
  };

  const getTimerAndProgressChip = () => {
    const details = getChipDetails(section.totalCards, section.cardsCompleted, section.cards);
    return (
      <Grid
        item
        marginX={isMobileScreen ? "0" : "16px"}
        marginY={"16px"}
        display={"flex"}
        flexDirection={"row"}
        justifyContent={isMobileScreen ? "space-between" : ""}
        width="100%"
      >
        <Timing variant="body1" duration={getHoursAndMin(getSectionDuration(section?.cards))} />
        {!open &&
          (planType === planTypes.MyPlans && selectedMyPlanDetail?.innCode !== ABOVE_PROPERTY ? (
            <>
              <Box marginLeft={"8px"}>
                <Chip
                  iconAtStart
                  icon={details.icon}
                  backgroundColor={details.backgroundColor}
                  label={details.label}
                  color={details.color}
                />
              </Box>
            </>
          ) : (
            <>
              {!isMobileScreen && (
                <Box display="flex" alignItems={"center"} marginLeft={"16px"}>
                  <Ellipse />
                </Box>
              )}

              <Box display="flex" marginLeft="16px">
                <Typography variant="body1" showBold>
                  {section?.cards ? `${section?.cards?.length}  ` : 0}
                </Typography>
                <Box marginLeft={"4px"}>
                  <Typography variant="body1">Action Cards</Typography>
                </Box>
              </Box>
            </>
          ))}
      </Grid>
    );
  };

  const getMarkCompleteButton = () => {
    return (
      !isViewMode && (
        <MarkCompleteButton
          variant="secondary"
          sx={{ marginLeft: isMobileScreen ? "none" : "auto" }}
          width={"auto"}
          source={{ source: "section", sectionId: section?.id }}
        />
      )
    );
  };

  return (
    <>
      <Feedback
        form=""
        actionStatus={{ shouldShow: isCopyLinkSuccess, variant: "success", timer: FEEDBACK_TIMER }}
        message="Link Copied"
      />
      <MUIAccordionSummary
        sx={{ padding: 0, margin: 0 }}
        onClick={handleAccordianOpen}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Grid container>
          <Grid item xs={12} sm={0.5} display="flex" justifyContent={{ xs: "space-between", sm: "flex-start" }}>
            <Grid
              sx={{
                backgroundColor: colorCode,
                width: "34px",
                height: "34px",
                borderRadius: "50%",
                color: "white",
                textAlign: "center"
              }}
            >
              <Typography sx={{ padding: "5px" }} variant="h5" showBold>
                {index + 1}
              </Typography>
            </Grid>
            {isMobileScreen &&
              (planType !== planTypes.AllPlans ? (
                <KebabMenu
                  value={{ id: section?.id, title: section?.name, summary: section?.summary }}
                  options={SectionMenu}
                />
              ) : (
                <KebabMenu
                  value={{ id: section?.id, title: section?.name, summary: section?.summary }}
                  options={getSectionKebabMenu()}
                  label="More Options"
                />
              ))}

            {!isMobileScreen && (
              <Box
                sx={{
                  borderLeft: `2px dashed ${colorCode}`,
                  margin: "-18px",
                  marginTop: "48px",
                  marginBottom: open ? "-20px" : "-50px"
                }}
              />
            )}
          </Grid>

          {isMobileScreen ? (
            <>
              <Grid item xs={12} marginBottom={"15px"} marginTop="29px">
                <Typography variant="h5" showBold color={tokens.Text.General.PrimaryHeadline}>
                  {section?.name}
                </Typography>
              </Grid>
              {!open && (
                <Grid item xs={12}>
                  <Divider />
                </Grid>
              )}
              {getTimerAndProgressChip()}
              {open && (
                <>
                  <Grid item xs={12} sm={3} marginTop="10px">
                    <Typography variant="body2" color={tokens.Text.General.PrimaryBody}>
                      {section?.summary}
                    </Typography>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    marginTop="16px"
                    marginBottom="60px"
                    display="flex"
                    flexWrap="wrap"
                    gap={"8px"}
                    onClick={(e) => e.stopPropagation()}
                    justifyContent={isMobileScreen && !section?.cards?.length ? "center" : "flex-start"}
                  >
                    {planType === planTypes.MyPlans && !multiCardSelect && open && (
                      <Button
                        startIcon={<AddIcon />}
                        variant="primary"
                        label="Add Action"
                        accessType={accessTypes.update}
                        onClick={handleOpenCreateMenu}
                      />
                    )}
                    {showMultiSelectButtons && (
                      <MultiSelectButtons
                        planId={planId}
                        planType={planType}
                        section={section}
                        multiCardSelect={multiCardSelect}
                        handleMultiSelectMode={handleMultiSelectMode}
                      />
                    )}
                    {planType === planTypes.MyPlans &&
                      !multiCardSelect &&
                      open &&
                      selectedMyPlanDetail?.innCode !== "ABOVE_PROPERTY" &&
                      getMarkCompleteButton()}
                  </Grid>
                </>
              )}
            </>
          ) : (
            <Grid item flexGrow="1">
              <Grid item display="flex" flexDirection="row">
                <Grid item xs={3} marginBottom={"15px"}>
                  <Box paddingLeft={"15px"}>
                    <Typography variant="h5" showBold color={tokens.Text.General.PrimaryHeadline}>
                      {section?.name}
                    </Typography>
                  </Box>
                </Grid>

                {planType !== planTypes.MulipleAssign && (
                  <Grid
                    item
                    xs={9}
                    onClick={(e) => e.stopPropagation()}
                    display="flex"
                    marginLeft={"40px"}
                    gap="8px"
                    flexWrap="wrap"
                  >
                    {planType === planTypes.MyPlans && !multiCardSelect && open && (
                      <Button
                        startIcon={<AddIcon />}
                        variant="primary"
                        label="Add Action"
                        accessType={accessTypes.update}
                        onClick={handleOpenCreateMenu}
                      />
                    )}
                    {open && showMultiSelectButtons && (
                      <MultiSelectButtons
                        planId={planId}
                        planType={planType}
                        section={section}
                        multiCardSelect={multiCardSelect}
                        handleMultiSelectMode={handleMultiSelectMode}
                      />
                    )}
                    {planType === planTypes.MyPlans &&
                      !multiCardSelect &&
                      selectedMyPlanDetail?.innCode !== "ABOVE_PROPERTY" &&
                      open &&
                      getMarkCompleteButton()}
                  </Grid>
                )}
              </Grid>
              {!open && <Divider sx={{ marginLeft: "12px" }} />}
              {getTimerAndProgressChip()}
            </Grid>
          )}

          {!isMobileScreen && (
            <Grid
              item
              display="flex"
              justifyContent={"end"}
              marginLeft="auto"
              gap={1}
              onClick={(e) => e.stopPropagation()}
            >
              {planType !== planTypes.AllPlans && planType !== planTypes.MulipleAssign && (
                <KebabMenu
                  value={{ id: section?.id, title: section?.name, summary: section?.summary }}
                  options={SectionMenu}
                />
              )}
              {planType === planTypes.AllPlans && (
                <KebabMenu
                  value={{ id: section?.id, title: section?.name, summary: section?.summary }}
                  options={getSectionKebabMenu()}
                  label="More Options"
                />
              )}
            </Grid>
          )}
          {!open && (
            <Grid item xs={12} display="flex" flexDirection="row-reverse" marginRight={"6px"}>
              <img src={ArrowDown} alt="Arrow Down" width="20px" height="20px" />
            </Grid>
          )}
        </Grid>
      </MUIAccordionSummary>
      {openDialog && (
        <DialogFormation
          title="Edit section"
          openDialog={openDialog}
          handleClose={handleCloseDialog}
          actionConfig={
            <div className="modal-config-wrapper">
              <Button
                variant="secondary"
                label="Cancel"
                onClick={handleCloseDialog}
                width={isMobileScreen ? "50%" : "25%"}
              />
              <Button variant="primary" label="Save" onClick={formSubmit} width={isMobileScreen ? "50%" : "25%"} />
            </div>
          }
        >
          <div className="vertical-center display-col">
            <EditSectionForm
              ref={formRef}
              item={{ Title: sectionTitleValue, Description: sectionDescriptionValue, SectionId: sectionId }}
              handleDialogClose={handleCloseDialog}
            />
          </div>
        </DialogFormation>
      )}
      <DeleteSection
        openDeleteDialog={openDeleteDialog}
        setOpenDeleteDialog={setOpenDeleteDialog}
        sectionId={sectionId}
        cardsCount={section?.cards?.length}
      />
      <Menu
        id="create-menu"
        anchorEl={anchorEl}
        open={openCreateMenu}
        onClose={handleCloseCreateMenu}
        sx={{
          ".MuiList-root": {
            padding: "0",
            margin: "8px"
          }
        }}
      >
        <MenuItem onClick={handleCreateNewAction}>
          <Box>
            <Typography variant="body2" showBold sx={{ color: tokens.Text.General.PrimaryHeadline }}>
              Create new Action
            </Typography>
            <Typography variant="label" sx={{ color: tokens.Text.General.Secondary }}>
              Tailor the action precisely to your needs
            </Typography>
          </Box>
        </MenuItem>
        <MenuItem onClick={handleCreateFromExisting}>
          <Box>
            <Typography variant="body2" showBold sx={{ color: tokens.Text.General.PrimaryHeadline }}>
              Copy Actions from Library
            </Typography>
            <Typography variant="label" sx={{ color: tokens.Text.General.Secondary, whiteSpace: "normal" }}>
              Save time by choosing from library actions
            </Typography>
          </Box>
        </MenuItem>
      </Menu>
    </>
  );
}

export default AccordionSummary;
